import { humanise } from 'module/ui/components/atoms/humanised-date';
import { Short01 } from 'module/ui/components/styles';
import { AccountPeopleProfile } from 'api/account-people/profile-type';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Collapsible, EmptyContent } from './collapsible-section';
import { TextWithCitations } from '../text-with-citations';

const Summary = styled.div`
  ${Short01};
  p {
    ${Short01};
    font-size: var(--font-size-base) !important;
    font-weight: var(--font-weight-regular) !important;
    line-height: var(--line-height-02) !important;
    letter-spacing: var(--letter-spacing-01) !important;
  }
`;

export interface LastEngagementProps {
  userProfile: AccountPeopleProfile;
}

export const LastEngagement: React.FC<LastEngagementProps> = ({
  userProfile: { userEngagementData },
}) => {
  const userBasedEngagementSummary =
    userEngagementData?.userBasedEngagementSummary;

  return (
    <Collapsible
      panelKey="last-engagement"
      title={
        <FormattedMessage
          id="account.people.profile.sections.last_engagement.title"
          values={{
            empty: userBasedEngagementSummary == null,
            date: humanise(moment(userBasedEngagementSummary?.sourceTime)),
          }}
        />
      }
    >
      {userBasedEngagementSummary != null ? (
        <Summary>
          <TextWithCitations
            value={userBasedEngagementSummary?.summary}
            citationMapping={userBasedEngagementSummary?.citationMapping}
          />
        </Summary>
      ) : (
        <EmptyContent>
          <FormattedMessage id="account.people.profile.sections.last_engagement.empty" />
        </EmptyContent>
      )}
    </Collapsible>
  );
};
